import { isAxiosError } from "axios";

export async function saveWithRefresh({
  save,
  refresh,
}: {
  save: () => Promise<void>;
  refresh: () => Promise<void>;
}): Promise<void> {
  try {
    await save();
  } catch (error) {
    if (
      isAxiosError<{ error?: unknown }>(error) &&
      typeof error.response?.data?.error === "string"
    ) {
      throw new Error(error.response.data.error, { cause: error });
    }
    throw error;
  } finally {
    // A failed request may have persisted settings before a later step failed.
    await refresh();
  }
}
